import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { defaultIsEmptyText, EditorPlaceHolder } from '../../../Outline/Paragraph/components/EditorPlaceHolder';
import { BaseQuestionListPluginProps } from '../QuestionListPlugin.types';

const Main = styled.li`
  font-weight: 600;
`;

interface QuestionListItemProps extends BaseQuestionListPluginProps {}

export const QuestionListItem = (props: QuestionListItemProps) => {
  const { attributes, children, element } = props;
  return (
    <Main {...attributes} className={cl('question-list-item-element', element.id)}>
      <EditorPlaceHolder
        isEmptyText={() => {
          return defaultIsEmptyText(element);
        }}
        placeHolderText="Viết, hoặc bấm enter để thêm câu hỏi"
      >
        {children}
      </EditorPlaceHolder>
    </Main>
  );
};
